let language = {
    STORE_ORDER_DELETE_SUCCESS: "Delete store retail order success",
    STORE_ORDER_DELETE_SUCCESS_CONTENT: "The customer order has been successfully deleted.",
    STORE_ORDER_DELETE_FAIL_TITLE: "Failed to delete store retail order",
    STORE_ORDER_DELETE_FAIL_CONTENT: "The customer order has already been combined and cannot be deleted",
    
    STORE_ORDER_DELETE_QUESTION_TITLE: "Delete Confirmation",
    STORE_ORDER_DELETE_QUESTION_CONTENT: "Are you sure you want to delete this customer order? Once deleted, it cannot be restored.",
};

export { language }